import styled from "styled-components";

export const Section = styled.section`
  //width: 100%;
  margin-bottom: 80px;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  align-items: flex-start;
`;

export const MainTitleContainer = styled.div`
  // width: 100%;
  border-bottom: 4px solid #fff;
  border-top: 4px solid #fff;
  padding: 10px;
  margin-bottom: 20px;
`;

export const Title = styled.span`
  font-size: 32px;
  color: #fff;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
`;
